import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageSliderProps {
  images: {
    src: string;
    alt: string;
  }[];
}
export const ImageSlider: React.FC<ImageSliderProps> = ({
  images
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="w-full space-y-4" data-id="element-186" data-mp="1b66ica037x41">
      <div className={`relative ${isExpanded ? 'h-auto' : 'h-64 md:h-80'} overflow-hidden rounded-lg`} data-id="element-187" data-mp="1b77tsfl0mlma">
        <div className="absolute inset-0 flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-188" data-mp="1661z4c7sooa4">
          {images.map((image, index) => <div key={index} className="min-w-full h-full flex-shrink-0" data-id="element-189" data-mp="3uwboigbriuj8" data-mpi={index}>
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover" data-id="element-190" data-mp="3g6xd72omm317" />
            </div>)}
        </div>
        <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full backdrop-blur-sm hover:bg-purple-500/50 transition-colors z-10" data-id="element-191" data-mp="3l3nutug2x6oq">
          <ChevronLeft size={20} data-id="element-192" data-mp="2sitqgnnrts0" />
        </button>
        <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full backdrop-blur-sm hover:bg-purple-500/50 transition-colors z-10" data-id="element-193" data-mp="2rrbs8mzhuk7">
          <ChevronRight size={20} data-id="element-194" data-mp="2nkkwdngswk5o" />
        </button>
        <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10" data-id="element-195" data-mp="2si4dqw8spd1u">
          {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2 h-2 rounded-full ${index === currentIndex ? 'bg-purple-400' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-196" data-mp="z0ov9v3wzpmx" data-mpi={index} />)}
        </div>
        {!isExpanded && <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/80 to-transparent" data-id="element-197" data-mp="famu3z4acnc9" />}
      </div>
      <button onClick={() => setIsExpanded(!isExpanded)} className="mx-auto block text-purple-400 hover:text-purple-300 transition-colors text-sm" data-id="element-198" data-mp="b7ym1tnebkgc">
        {isExpanded ? 'Show More' : 'Show Less'}
      </button>
    </div>;
};